import { render, staticRenderFns } from "./DashboardContactInfos.vue?vue&type=template&id=ac1c6dc0&"
import script from "./DashboardContactInfos.vue?vue&type=script&lang=js&"
export * from "./DashboardContactInfos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContactInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports